"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SetupIdeaStatusMappingWarning = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

/* eslint-disable import/prefer-default-export */
var SetupIdeaStatusMappingWarning = function SetupIdeaStatusMappingWarning(_ref) {
  var count = _ref.count,
      openModal = _ref.openModal;
  var countPrefix = count && count === 1 ? 'is' : 'are';
  var status = count && count === 1 ? 'status' : 'statuses';
  return (0, _preact.h)("div", {
    className: "warning-box"
  }, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning",
    width: 20,
    height: 20
  }), "There ", countPrefix, " ", count, " unmapped idea ", status, ", please ", (0, _preact.h)("a", {
    "data-element-name": "Update status mapping button",
    "data-track-type": "click",
    onClick: function onClick() {
      return openModal();
    }
  }, "update status mapping"), ".");
};

exports.SetupIdeaStatusMappingWarning = SetupIdeaStatusMappingWarning;